enum MileageContractListingFilterType {
  CARGO_COMPANY = "CARGO_COMPANY",
}

export default MileageContractListingFilterType;
